import React from "react"
import classnames from "classnames"
import DatePicker from "components/ui/DatePicker"
import { func, number, oneOfType, string } from "prop-types"

const AttendeeTypeAgeFilter = props => {
  const {
    ageRestrictionPhrase,
    ageRestrictionUnit,
    evaluateAgeAt,
    maxAge,
    minAge,
    onAgeRestrictionPhraseChange,
    onAgeRestrictionUnitChange,
    onEvaluateAgeAtChange,
    onMaxAgeChange,
    onMinAgeChange
  } = props

  const minAgeFieldClassname = {
    "d-n": ageRestrictionPhrase === "at_most"
  }
  const maxAgeFieldClassname = {
    "d-n": ageRestrictionPhrase === "at_least" || ageRestrictionPhrase === "exactly"
  }

  const getMinAge = () => {
    if (ageRestrictionPhrase === "at_most") {
      return ""
    } else {
      return minAge
    }
  }

  const getMaxAge = () => {
    if (ageRestrictionPhrase === "at_least") {
      return ""
    } else if (ageRestrictionPhrase === "exactly") {
      return minAge
    } else {
      return maxAge
    }
  }

  return (
    <div className="mb-2 d-f ai-c g-1 fw-w">
      <select
        id="age_restriction_phrase"
        className="select select--inline"
        name="age_restriction_phrase"
        onChange={onAgeRestrictionPhraseChange}
        value={ageRestrictionPhrase}
      >
        <option value="between">between</option>
        <option value="at_least">at least</option>
        <option value="at_most">at most</option>
        <option value="exactly">exactly</option>
      </select>

      <input
        id="attendee_type_min_age"
        autoComplete="off"
        className={classnames(minAgeFieldClassname)}
        min="0"
        name="attendee_type[min_age]"
        onChange={onMinAgeChange}
        style={{ maxWidth: "64px" }}
        type="number"
        value={getMinAge()}
      />

      {ageRestrictionPhrase === "between" && <span>and</span>}

      <input
        id="attendee_type_max_age"
        autoComplete="off"
        className={classnames(maxAgeFieldClassname)}
        min="0"
        name="attendee_type[max_age]"
        onChange={onMaxAgeChange}
        style={{ maxWidth: "64px" }}
        type="number"
        value={getMaxAge()}
      />

      <select
        id="attendee_type_age_restriction_unit"
        className="select select--inline"
        name="attendee_type[age_restriction_unit]"
        onChange={onAgeRestrictionUnitChange}
        value={ageRestrictionUnit}
      >
        <option value="0">Months</option>
        <option value="1">Years</option>
      </select>

      {ageRestrictionPhrase === "exactly" ? <span>on</span> : <span>by</span>}
      <DatePicker className="w-a!" datetime={evaluateAgeAt} onChange={onEvaluateAgeAtChange} />
      <input type="hidden" name="attendee_type[evaluate_age_at]" value={evaluateAgeAt} />
    </div>
  )
}

AttendeeTypeAgeFilter.propTypes = {
  ageRestrictionPhrase: string.isRequired,
  ageRestrictionUnit: number.isRequired,
  evaluateAgeAt: string.isRequired,
  maxAge: oneOfType([string, number]).isRequired,
  minAge: oneOfType([string, number]).isRequired,
  onAgeRestrictionPhraseChange: func,
  onAgeRestrictionUnitChange: func,
  onAnyAgeChange: func,
  onEvaluateAgeAtChange: func,
  onMaxAgeChange: func,
  onMinAgeChange: func
}

export default AttendeeTypeAgeFilter
